import { RunSummary } from "@shared/lib/database/query.types";
import { addHours, isAfter, isBefore, isWithinInterval, parseISO, subHours, subMilliseconds } from "date-fns";
import { computed, Ref } from "vue";
import useNow from "./useNow";

export default function (run: Ref<RunSummary>) {
  const {
    now,
  } = useNow();

  // TODO: refactor with useRunSchedule
  const startDate = computed(() => parseISO(run.value.start_at));
  const endDate = computed(() => run.value.end_at ? parseISO(run.value.end_at) : null);

  const hasRunStarted = computed(() => {
    return isAfter(now.value, startDate.value);
  });

  const hasRunEnded = computed(() => {
    return isBefore(endDate.value || addHours(startDate.value, 3), now.value);
  });

  const isRunApproaching = computed(() => {
    return !run.value.canceled_at && isWithinInterval(now.value, {
      start: subHours(startDate.value, 1),
      end: subMilliseconds(startDate.value, 1),
    });
  });

  const isRunActive = computed(() => {
    return !run.value.canceled_at && isWithinInterval(now.value, {
      start: startDate.value,
      end: endDate.value || addHours(startDate.value, 3),
    });
  });

  const isRunActiveOrApproaching = computed(() => {
    return isRunApproaching.value || isRunActive.value;
  });

  return {
    hasRunStarted,
    hasRunEnded,
    isRunApproaching,
    isRunActive,
    isRunActiveOrApproaching,
  };
}
